import React from 'react';
import '../components/styles/ScrollWheel.css';

export default function ScrollWheel() {
  return (
    <div className='anim-scroll'>
      <div class='wheel'></div>
    </div>
  );
}
